import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroupMUI from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import { ReactElement, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import DateRangePicker from '~/ui/components/inputs/DateRangePicker';
import Checkbox from '~/ui/components/inputs/Checkbox';
import { AllocationMode, allocationModeOptions } from '../../../constants/allocationMode';
import { useAddClientAllocationContext } from '../../../AddClientAllocation/context/AddClientAllocationContext';
import { IAddAllocationFormValues } from '../../../AddClientAllocation/types';
import { IDatesValidation } from '~/services/api/clientAllocation';

import styles from './AddAllocationFormLayout.module.scss';

interface IProps {
  title: string;
  isRestored: boolean;
  children: ReactNode;
  datesValidation: IDatesValidation;
}

const AddAllocationFormLayout = ({
  title,
  isRestored,
  datesValidation,
  children,
}: IProps): ReactElement => {
  const { allocationMode, setAllocationMode } = useAddClientAllocationContext();

  const {
    control,
    formState: { errors },
  } = useFormContext<IAddAllocationFormValues>();

  return (
    <Paper>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item sm={12} className={styles.titleRow}>
            <Typography variant="subtitle1" className={styles.assignedClientsTitle}>
              {title}
            </Typography>
          </Grid>

          <Grid item sm={4}>
            <DateRangePicker
              label="Select Date Range"
              control={control}
              name="dateRange"
              errors={errors}
            />
          </Grid>

          <Grid item sm={3}>
            <Checkbox
              name="includeWeekends"
              size="small"
              control={control}
              label="Include weekends"
              errors={errors}
            />
          </Grid>

          <Grid item sm={5}>
            <RadioGroupMUI
              row
              value={allocationMode}
              onChange={(_, value) => setAllocationMode(value as AllocationMode)}
            >
              {allocationModeOptions.map(option => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  label={option.label}
                  control={<Radio color="primary" size="small" />}
                />
              ))}
            </RadioGroupMUI>
          </Grid>
        </Grid>

        {!datesValidation?.isValid && !!datesValidation?.users?.length && (
          <Grid item sm={12} container direction="row" alignItems="center">
            <h5 className={styles.validationErrors}>
              {`Note: ${datesValidation.users.length} team member${
                datesValidation.users.length > 1 ? 's' : ''
              } already ${
                datesValidation.users.length > 1 ? 'have' : 'has'
              } allocations within this period!`}
            </h5>
          </Grid>
        )}

        {isRestored && <div className={styles.formWrapper}>{children}</div>}
      </Box>
    </Paper>
  );
};

export default AddAllocationFormLayout;
